import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
const ModeContext = createContext({
    mode: 'operator',
    setMode: () => { },
});
/** Sets `data-mode` on the root element (or the provided host). */
function applyMode(mode, host = null) {
    if (typeof document === 'undefined')
        return;
    const el = host ?? document.documentElement;
    if (mode === 'operator') {
        el.removeAttribute('data-mode');
    }
    else if (mode === 'boardroom') {
        el.setAttribute('data-mode', 'boardroom');
    }
    else if (mode === 'system') {
        el.removeAttribute('data-mode');
    }
}
export function ModeProvider({ initialMode = 'operator', hostRef, children }) {
    const [mode, setMode] = useState(initialMode);
    useEffect(() => {
        applyMode(mode, hostRef?.current ?? null);
    }, [mode, hostRef]);
    return _jsx(ModeContext.Provider, { value: { mode, setMode }, children: children });
}
export function useMode() {
    return useContext(ModeContext);
}
/** Convenience wrappers for surfaces that lock a mode in place. */
export function OperatorMode({ children }) {
    return _jsx(ModeProvider, { initialMode: "operator", children: children });
}
export function BoardroomMode({ children }) {
    return _jsx(ModeProvider, { initialMode: "boardroom", children: children });
}
export function SystemMode({ children }) {
    return _jsx(ModeProvider, { initialMode: "system", children: children });
}
//# sourceMappingURL=ModeProvider.js.map